import styles from './Content.module.scss';
import {Component} from "react";
import cn from "classnames";
import data from './data';
import {Element} from "../Element/Element";
import {First, Second, Third} from "../Cards";

const randomValue = Math.floor(Math.random() * data.length + 1),
    randomElement = data[randomValue - 1];

const results = [<First random={randomValue} element={randomElement}/>, <Second/>, <Third/>],
    currentResults = [<div/>, <div/>, <div/>];

export class Content extends Component {
    state = {
        step: 0
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        let images = [`${process.env.PUBLIC_URL}/characters/${randomValue}.png`],
            promises = [];

        images.forEach(image => {
            promises.push(new Promise((resolve, reject) => {
                const newImage = new Image();

                newImage.addEventListener("load", function () {
                    resolve();
                });

                newImage.src = image;
                window[image] = newImage;
            }));
        });
    }

    checker = (id) => {
        const step = this.state.step;
        currentResults[id] = results[step];

        this.setState(({step}) => ({step: ++step}));
    }

    render() {
        const elementsList = [0, 1, 2].map(item => {
            return <Element clickHandler={() => this.checker(item)} key={item} id={item} children={currentResults[item]} />
        });

        return (
            <div className={styles.content}>
                <div className={styles.wrapper}>
                    <div className={styles.list}>
                        {elementsList}
                    </div>
                    <a href="https://online.2x2tv.ru" target="_blank" rel="nofollow noreferrer" className={cn("button", styles.button, this.state.step === 3 ? styles.active : '')}>
                        <span>Смотрите премьеру «Колдуй отсюда» 31 декабря в 21:00</span>
                    </a>
                </div>
                <div className={cn(styles.bg, styles.bg_bottom_1)}/>
                <div className={cn(styles.bg, styles.bg_bottom_2)}/>
                <div className={cn(styles.bg, styles.bg_bottom_3)}/>
                <div className={cn(styles.bg, styles.bg_bottom_4)}/>
            </div>
        )
    }
}